// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Features_wrapper__1w2pc","grid":"Features_grid__QBBfE","feature":"Features_feature__oxzge","title":"Features_title__2KNtw","description":"Features_description__7oau7"};